import { render } from "./ConsumerItemPrice.vue?vue&type=template&id=9c538930"
import script from "./ConsumerItemPrice.vue?vue&type=script&lang=js"
export * from "./ConsumerItemPrice.vue?vue&type=script&lang=js"

import exportComponent from "/Users/engkhiongsoh/dev/marketanalysis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__